import React from 'react';
import SimilarSuggestionCard from '../ext/SimilarSuggestionCard';

/** Карточка предложения аналога — обёртка над унифицированным SimilarSuggestionCard */
const AnalogSuggestionCard = ({ analog, onToggleLock }) => (
  <SimilarSuggestionCard variant="analog" item={analog} onToggleLock={onToggleLock} />
);

export default AnalogSuggestionCard;
